module.exports = __webpack_public_path__ + "static/media/football-helmet.5500bd55.svg";